<template>
  <div class="node-report-thru-info"
       :class="{ open: isThruInfoVisible }">
    <h5>
      <i class="icon icon--ring" />
      {{ $t('trend.thruReport.title') }}
    </h5>
    <button type="button"
            class="more-button"
            @click="toggleThruInfo">
      {{ $t('trend.thruReport.infoTitle') }}
    </button>
    <div class="content-mask">
      <div class="content"
           ref="thruInfoContent">
        <h6>
          {{ $t('trend.thruReport.infoTitle') }}
          <i class="icon icon--info-outline-size17"
             @mouseenter="isNodeInfoHelperVisible = true"
             @mouseleave="isNodeInfoHelperVisible = false" />
          <ui-tooltip v-show="isNodeInfoHelperVisible"
                      :class="$i18n.locale"
                      arrowTop />
        </h6>
        <p class="description">{{ $t('trend.thruReport.infoDescription') }}</p>
        <div class="sequence-info">
          <p class="sequence">
            <strong>{{ highlightedSequenceIndex + 1 }}</strong>
            {{ $t('common.sequence') }}
          </p>
          <p class="rank">
            <strong>{{ highlightedNodeIndex + 1 }}</strong>
            {{ $t('common.rank') }}
          </p>
        </div>
        <dl class="node-info">
          <dt>{{ $t('trend.thruReport.nodeTitle') }}</dt>
          <dd>{{ highlightedNodeInfo.title }}</dd>
          <dt>{{ $t('trend.thruReport.nodeUrl') }}</dt>
          <dd>{{ highlightedNodeInfo.linkUrl }}</dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import UiTooltip from '@/components/ui/UiTooltip'

export default {
  name: 'BaNodeReportThruInfo',
  components: {
    UiTooltip
  },
  props: {
    highlightedSequenceIndex: {
      type: Number,
      required: true
    },
    highlightedNodeIndex: {
      type: Number,
      required: true
    },
    highlightedNodeInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isThruInfoVisible: false,
      isNodeInfoHelperVisible: false
    }
  },
  methods: {
    toggleThruInfo (e) {
      e.preventDefault()
      if (!this.isThruInfoVisible) {
        this.$refs.thruInfoContent.parentNode.style.height = this.$refs.thruInfoContent.offsetHeight + 'px'
        this.isThruInfoVisible = true
      } else {
        this.isThruInfoVisible = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.node-report-thru-info {
  position: relative;
  margin: -12px -12px 25px;
  border-radius: 5px;
  background-color: #f4e439;

  h5 {
    position: relative;
    height: 28px;
    font-size: 12px;
    font-weight: normal;
    color: #444;
    line-height: 30px;
    padding: 0 40px 0 32px;

    .icon {
      position: absolute;
      left: 4px;
      top: 4px;
    }
  }

  .more-button {
    position: absolute;
    right: 0;
    top: 0;
    width: 36px;
    height: 28px;
    text-indent: -999em;
    overflow: hidden;

    &:before {
      position: absolute;
      left: 0;
      top: 7px;
      bottom: 7px;
      content: '';
      border-left: 1px solid #fff;
    }

    &:after {
      position: absolute;
      left: 10px;
      top: 6px;
      width: 16px;
      height: 16px;
      content: '';
      background: url('../../assets/img/trend/icon--more-gray.svg') no-repeat;
      transition: transform 0.35s $ease-out-quart;
    }
  }
  &.open .more-button {
    &:after {
      transform: rotateZ(-180deg);
    }
  }

  .content-mask {
    position: relative;
    overflow: hidden;
    transition: height 0.35s $ease-out-quart, opacity 0.1s ease-out;
  }
  &:not(.open) .content-mask {
    height: 0 !important;
    opacity: 0;
  }

  .content {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 21px 20px 10px;

    h6 {
      position: relative;
      font-size: 18px;
      font-weight: bold;
      color: #0e90a5;
      line-height: 1;

      .icon {
        width: 17px;
        height: 17px;
        vertical-align: middle;
        margin-left: 2px;
        background: url('../../assets/img/trend/icon--info-outline-size17.svg') no-repeat;
        display: inline-block;
        transform: translateY(-2px);
      }

      .bubble {
        left: auto;
        top: auto;
        width: 200px;
        height: 132px;
        margin: 24px 0 0 -76px;
        padding: 22px 20px;
        box-sizing: content-box;
        background: #fff url('../../assets/img/trend/img-node-thru-info-kr.svg') no-repeat 20px 22px;

        &.en {
          background-image: url('../../assets/img/trend/img-node-thru-info-en.svg');
        }
        &.ja {
          background-image: url('../../assets/img/trend/img-node-thru-info-jp.svg');
        }

        & /deep/ .arrow.top.left {
          left: 63px;
        }
      }
    }

    .description {
      font-size: 12px;
      color: #0e90a5;
      line-height: 1.33;
      margin-top: 4px;
    }

    .sequence-info {
      position: relative;
      margin-top: 15px;
      padding: 11px 0 13px;
      border-radius: 6px;
      background-color: #fff;
      box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.35);
      display: flex;

      p {
        flex: 1;
        font-size: 13px;
        font-weight: 500;
        color: #444;
        text-align: center;
        line-height: 1;

        strong {
          font-size: 24px;
          font-weight: bold;
          line-height: 1;
          margin-bottom: 1px;
          display: block;
        }

        &.rank {
          color: #0e90a5;
        }
      }

      &:after {
        position: absolute;
        left: 50%;
        top: 17px;
        bottom: 20px;
        content: '';
        border-left: 1px solid #e4e4e4;
      }
    }

    .node-info {
      font-size: 12px;
      font-weight: normal;
      line-height: 1.33;
      word-break: break-all;
      margin-top: 9px;
      overflow: hidden;

      dt {
        clear: both;
        float: left;
        font-weight: 500;
        color: #444;
        padding: 11px 0 10px;
      }

      dd {
        position: relative;
        float: right;
        width: calc(100% - 102px);
        color: #555;
        padding: 11px 0 10px;
      }

      dd ~ dd:before {
        position: absolute;
        left: -102px;
        right: 0;
        top: 0;
        content: '';
        border-top: 1px dashed #d1c22a;
      }
    }
  }
}
</style>
